import { ANALYTICS_KEY } from '../../constants.js';
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import '../Div/index.js';
import { Pressable } from '../Button.js';
import { LinkPressable } from '../Link/LinkPressable.js';
import { jsx } from 'react/jsx-runtime';
import { Div } from '../Div/Div.js';
function SvgLink({
  link,
  onClick,
  svg,
  background
}) {
  const content = /*#__PURE__*/jsx(Div, {
    borderColor: "line",
    bordered: true,
    spacing: 1,
    borderRadius: "roundedFull",
    alignItems: "center",
    justifyContent: "center",
    background: background,
    css: {
      transition: 'background 250ms'
    },
    width: 32,
    height: 32,
    children: svg
  });
  if (link) {
    return /*#__PURE__*/jsx(LinkPressable, {
      href: link || '',
      rel: "noopener noreferrer",
      target: "_blank",
      "data-qa": ANALYTICS_KEY.SvgLink,
      children: content
    });
  }
  return /*#__PURE__*/jsx(AnalyticsProvider, {
    analyticsPrefix: ANALYTICS_KEY.SvgContent,
    children: /*#__PURE__*/jsx(Pressable, {
      background: "transparent",
      onPress: onClick,
      children: content
    })
  });
}
export { SvgLink };
//# sourceMappingURL=SvgLink.js.map
